import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';

export default function NewsroomChooserRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.NewsroomChooser', {
		url: '/newsroom/chooser',
		controllerAs: 'vm',
		controller: NewsroomChooserCtrl,
		templateUrl: '/ng/hub/Newsroom/Chooser/NewsroomChooserCtrl.html?' + window.BUILD,
		resolve: {
			$style: () => AssetManager.css('/ng/hub/Newsroom/Chooser/NewsroomChooserCtrl.css'),
			types: ApiResourcify.endpoint('/newsrooms/screens/types', { cacheFor: 30 * 60 * 1000 }),
			defaultColorScheme: ApiResourcify.endpoint('/newsrooms/color_schemes/default', {
				cacheFor: 30 * 60 * 1000,
			}),
		},
	});
}

class NewsroomChooserCtrl {
	constructor(Api, types, defaultColorScheme) {
		'ngInject';
		this.Api = Api;
		this.types = types;
		this.defaultColorScheme = defaultColorScheme;
	}

	create(type) {
		// Create new screen
		let data = {
			type: type,
			color_scheme_id: Number(this.defaultColorScheme.id) || 10001,
			name: 'Untitled',
		};
		this.Api.request('post', '/newsrooms/screens', data).then(response => {
			// Get data for the newly created screen
			let id = response.headers('api-new-record-id');
			// go to the new screen
			window.location.href = `#/newsroom/screens/${id}`;
			// close this modal
			this.$reject();
		});
	}
}
